$(document).ready(function() {
  const duration = 4000;

  $('.explained__container').each(function() {
    const $scope = $(this);
    let currentIndex = 1;
    const totalItems = $scope.find('.explained__list .item').length;

    function startProgress(index) {
      // reset sólo dentro del contenedor actual
      $scope.find('.progressbar-bar').stop(true).height('0%');
      $scope.find('.item p').removeClass('active-text');

      const $progressBar = $scope.find('.item-' + index + ' .progressbar-bar');
      const $image      = $scope.find('.explained__imagenes .item-image.item-' + index);
      const $text       = $scope.find('.item-' + index + ' p');

      // mostrar/ocultar imágenes sólo dentro de este contenedor
      $scope.find('.explained__imagenes .item-image').hide();
      $image.show();
      $text.addClass('active-text');

      $progressBar.animate({ height: '100%' }, duration, function() {
        let nextIndex = index + 1;
        if (nextIndex > totalItems) nextIndex = 1;
        startProgress(nextIndex);
      });

      currentIndex = index;
    }

    // iniciar
    startProgress(currentIndex);

    // click sólo dentro del contenedor
    $scope.find('.item').on('click', function() {
      const clickedIndex = $(this).data('index');
      $scope.find('.progressbar-bar').stop(true);
      startProgress(clickedIndex);
    });
  });
});

